import React, { useState } from 'react';
import { required, email, Create, SimpleForm, TextInput, useRedirect, SelectInput, PasswordInput, minLength } from 'react-admin';
import validateEmail from '../../validators/EmailValidator'
import passwordsMatch from '../../validators/passwordsMatch'
import DataProvider from '../../DataProvider.js'
import useUser from '../../hooks/useUser';
import EditConfirmToolbar from '../../components/EditConfirmToolbar'
import { parse } from "query-string";
import ListSelect from '../../components/ListSelect'

const UserCreate = (props) => {

    const user = useUser()

    const { organization_id } = parse(props.location.search);

    const redirectTo = useRedirect();

    const [orgs, setOrgs] = useState(null)
    const updateOrgs = (data) => setOrgs(data)

    if (!orgs && organization_id) setOrgs([parseInt(organization_id)])

    const createUser = async (data) => {
        if (data.role === 'super-admin') {
            data.superPW = confirmSuperAdmin()
        }
        await uploadData(data)
    }

    const confirmSuperAdmin = () => {
        return window.prompt('WARNING! You are attempting to create a super admin, if you wish to continue you must enter your password. A record of this creation will be logged.');
    }

    const uploadData = async (data) => {
        let _orgs = []
        if (orgs && orgs.length > 0) for (let org of orgs) _orgs.push(org.id)
        try {
            const cL = await DataProvider.create('users', { data: { ...data, organization_ids: _orgs }, })
            organization_id ? redirectTo('show', '/Organizations', organization_id) : redirectTo('show', props.basePath, cL.data.id, cL)
        } catch (e) {
            alert('The user was not created. You may be unauthorized to create this user, or the password you entered while creating this user was incorrect.')
        }
    }

    return (
        <Create {...props}>
            <SimpleForm toolbar={<EditConfirmToolbar handlesave={createUser} creating={true} history={props.history} />} >
                {user.role === 'super-admin' ?
                    <SelectInput fullWidth label="Role" source="role" choices={[
                        { id: 'super-admin', name: 'Super Admin' },
                        { id: 'channel-admin', name: 'Channel Admin' },
                        { id: 'org-admin', name: 'Organization Admin' },
                    ]} validate={[required()]} />
                    : <SelectInput fullWidth label="Role" source="role" choices={[
                        { id: 'channel-admin', name: 'Channel Admin' },
                        { id: 'org-admin', name: 'Organization Admin' },
                    ]} validate={[required()]} />}
                <TextInput fullWidth label="First Name" source="firstName" validate={[required()]} />
                <TextInput fullWidth label="Last Name" source="lastName" validate={[required()]} />
                <TextInput resettable fullWidth label="Email" source="email" validate={[email(), required(), validateEmail]} />

                <PasswordInput fullWidth source="password" inputProps={{ autocomplete: 'new-password' }} validate={[passwordsMatch, required(), minLength(10)]} />
                <PasswordInput fullWidth source="confirm-password" inputProps={{ autocomplete: 'new-password' }} validate={[passwordsMatch, required(), minLength(10)]} />
                <ListSelect
                    {...props}
                    headers={['Name']}
                    sources={['name']}
                    filters={[{ source: 'name', placeholder: 'Add organization by name:' }]}
                    filterorgid={false}
                    target="Organizations"
                    selectedsource="organization_ids"
                    defaultids={orgs}
                    updatestate={updateOrgs} />
            </SimpleForm>
        </Create>
    );
}
export default UserCreate